import React, { Component, Fragment } from 'react'
import StatusPageMixin from 'containers/shared/StatusPageMixin'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import * as Icons from 'components/icons'
import StyleSheet from 'styles'

export class NoAccount extends StatusPageMixin(Component){
  body = () => {
    const user = this.props.currentUser
    let noAccountBody
    if (user.issuerStatus === 'draft')
      noAccountBody = this.renderSignup('issuer')
    else
      noAccountBody = this.renderSignup('investor')
    return (
      <div style={{maxWidth: 400, textAlign: 'left'}}>
        {noAccountBody}
      </div>
    )
  }

  renderSignup = (accountType) =>
    <Fragment>
      <Typography variant='h6'>Email Confirmation Success</Typography>
      <br/>
      <Icons.Tick className={styles.tick} width={96} height={96}/>
      <br/>
      <Typography variant='body1' paragraph>The next step is Account Registration</Typography>
      <Typography variant='body2' paragraph>All users of {process.env.REACT_APP_NAME} portal must read and acknowledge the terms, conditions and disclaimers before acquiring NZDs.</Typography>
      <Typography variant='body2' paragraph>Before acquiring NZDs, you will be required to comply with Anti-Money Laundering (AML) and Counter Financing of Terrorism (CFT) requirements, including Know Your Customer (KYC) verification.</Typography>
      <Button fullWidth variant='contained' color="primary" onClick={() => this.props.history.push(`/${accountType}/${this.props.currentUser.id}/edit`)}>Continue</Button>&emsp;
    </Fragment>

}


const styles = StyleSheet({
  link: {
    fontSize: 11,
    marginTop: 20,
    display: 'block',
    color: '#b9b39b',
    textAlign: 'center',
    width: '100%'
  },
  tick: {
    margin: '0 auto',
    display: 'block'
  }
})
export default connect(({tokens}) => tokens)(NoAccount)